import type { NoiseFilterState } from '@cli-types/next-adapter/utils.js'
import { shouldSuppressOutputLine } from './should-suppress-output-line.js'

export function filterNoiseLines(output: string, state: NoiseFilterState): string {
  const lines = output.match(/[^\n]*\n|[^\n]+/g) ?? []
  return lines.filter((line) => !shouldSuppressOutputLine(line, state)).join('')
}
